<section class="content-header" style="padding: 0.5% !important;">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-6">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">Thông tin học phí lệ phí</li>
                </ol>
            </div>
            <div class="col-md-6">
                <button class="btn btn-primary btn-sm" (click)="submit()" style="float: right; margin-right: 5px;">
                    <i class="fas fa-search"></i> Thống kê dữ liệu </button>
            </div>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <form class="form-horizontal" [formGroup]="filter">
                <div class="row">
                    <div class="col-md-2 ">
                        <label>Hệ</label>
                        <select class="form-control" (change)="changeHe()" formControlName="ID_he">
                            <option *ngFor="let i of dataHe" value="{{i.ID_he}}">{{i.Ten_he}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khoa</label>
                        <select class="form-control" formControlName="ID_khoa" (change)="changeKhoa()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoa" value="{{i.ID_khoa}}">{{i.Ten_khoa}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Khóa</label>
                        <select class="form-control" formControlName="Khoa_hoc" (change)="changeKhoaHoc()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataKhoaHoc2" value="{{i.Khoa_hoc}}">{{i.Khoa_hoc}}</option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Chuyên ngành</label>
                        <select class="form-control" formControlName="ID_chuyen_nganh" (change)="changeChuyenNganh()">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataChuyenNganh2" value="{{i.ID_chuyen_nganh}}">{{i.Chuyen_nganh}}
                            </option>
                        </select>
                    </div>
                    <div class="col-md-2">
                        <label>Lớp</label>
                        <select class="form-control" formControlName="ID_lop">
                            <option value="">Tất cả</option>
                            <option *ngFor="let i of dataLop2" value="{{i.ID_lop}}">{{i.Ten_lop}}</option>
                        </select>
                    </div>

                </div>
                <div class="row">
                    <div class="col-md-2">
                        <label>Mã sv</label>
                        <input class="form-control" formControlName="Ma_sv">
                    </div>
                    <div class="col-md-2">
                        <label>Họ tên</label>
                        <input class="form-control" formControlName="Ho_ten">
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
<section class="content cus-body">
    <div class="card">
        <div class="card-body">
            <div class="table-responsive" style="width: 100%;height: auto; max-height: 50vh;">
                <table class="table table-bordered table-sm table-striped" style="width: 100%;">
                    <thead>
                        <tr>
                            <th>Mã sinh viên </th>
                            <th>Họ tên</th>
                            <th>Ngày sinh </th>
                            <th>Tên lớp </th>
                            <th class="text-center">Thao tác </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of dataTable">
                            <td>{{item.Ma_sv}}</td>
                            <td>{{item.Ho_ten}}</td>
                            <td>{{item.Ngay_sinh | date:'dd/MM/yyyy' }}</td>
                            <td>{{item.Lop}}</td>
                            <td style="white-space: nowrap;text-align: center;">
                                <button ngbTooltip="Thông tin biên lai" class="btn btn-sm btn-info" (click)="open(Info,'xl','Update',item)"
                                    style="margin-right: 7px;">
                                    <i class="fas fa-info-circle"></i></button>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</section>

<ng-template #Info let-modal>
    <div class="modal-header m-header text-center" style="padding-top: 0px;padding-bottom: 0px;">
        <h4 class="modal-title h-title w-100"> Thông tin học phí lệ phí</h4>
        <span (click)="modal.dismiss('Cross click')" aria-hidden="true" style="font-size: 25px;">&times;</span>
    </div>
    <div class="modal-body">
        <form class="form-horizontal">
            <div class="card-body">

                <div class="row">
                    <div class="col-md-4">
                        <label>Mã sinh viên: {{recorData.Ma_sv}}</label>
                        </div>
                    <div class="col-md-4">
                    <label>Họ tên: {{txtHo_ten}}</label>
                    </div>
                    <div class="col-md-4">
                        <label>Lớp: {{txtLop}}</label>
                    </div>
                </div>
                <div class="row">
                    <p><b>I.CÁC KHOẢN PHẢI NỘP</b> </p>
                    <div class="table-responsive" style="width: 100%;height: auto; max-height: 30vh;">
                        <table class="table table-bordered table-sm table-striped" style="width: 100%;">
                            <thead>
                                <tr>
                                    <th>Tên thu chi </th>
                                    <th>Học kì </th>
                                    <th>Năm học </th>
                                    <th>Số tiền phải nộp </th>  
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of dataKhoanThu">
                                    <td>{{item.Ten_thu_chi}}</td>
                                    <td>{{item.Hoc_ky}}</td>
                                    <td>{{item.Nam_hoc }}</td>
                                    <td>{{item.So_tien_con_nop | number}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <p> <b>II.CÁC BIÊN LAI THU/CHI</b></p>
                    <div class="table-responsive" style="width: 100%;height: auto; max-height: 30vh;">
                        <table class="table table-bordered table-sm table-striped" style="width: 100%;">
                            <thead>
                                <tr>

                                    <th>Học kì </th>
                                    <th>Năm học </th>
                                    <th>Ký hiệu </th>
                                    <th>Số phiếu </th>
                                    <th>Ngày tháng </th>
                                    <th>Người thu/chi </th>
                                    <th>Khoản thu/chi </th>
                                    <th>Số tiền </th>
                                    <th>Loại </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of dataBienLaiThu">

                                    <td>{{item.Hoc_ky}}</td>
                                    <td>{{item.Nam_hoc }}</td>
                                    <td>{{item.Ky_hieu}}</td>
                                    <td>{{item.So_phieu}}</td>
                                    <td>{{item.Ngay_thang | date:'dd/MM/yyyy'}}</td>
                                    <td>{{item.Nguoi_thu}}</td>
                                    <td>{{item.Ten_thu_chi}}</td>
                                    <td>{{item.So_Tien_Thuc_Nop | number}}</td>
                                    <td>
                                        <div *ngIf="item.Thu_chi">
                                                Thu
                                        </div>
                                        <div *ngIf="!item.Thu_chi">
                                            Chi
                                    </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <p><b>III.TỔNG HỢP CHUNG</b></p>
                    <div class="table-responsive" style="width: 100%;height: auto; max-height: 30vh;">
                        <table class="table table-bordered table-sm table-striped" style="width: 100%;">
                            <thead>
                                <tr>
                                    <th>Khoản thu</th>
                                    <th>Số tiền phải nộp </th>
                                    <th>Số tiền đã nộp </th>
                                    <th>Số tiền hoàn trả </th>
                                    <th>Số tiền thiếu/thừa </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of dataTHKhoanThu">
                                    <td>{{item.Ten_thu_chi}}</td>
                                    <td>{{item.So_tien_phai_nop | number}}</td>
                                    <td>{{item.So_tien_da_nop | number}}</td>
                                    <td>{{item.So_tien_hoan_tra | number}}</td>
                                    <td>{{item.So_tien_thieu_thua | number}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-6">
                    <label><b>Số tiền phải nộp : {{Tong_phai_nop | number}}</b></label>
                    </div>
                    <div class="col-md-6">
                        <label><b>Số tiền đã nộp : {{Tong_da_nop | number}}</b></label>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer">
        <div class="float-right">
            <button type="button" class="btn btn-md btn-danger" (click)="modal.dismiss('Cross click')">
                <i class="far fa-times-circle"></i> Đóng
            </button>
        </div>
    </div>
</ng-template>